// extracted by mini-css-extract-plugin
export var dateTimeButton = "_ef-1";
export var dateTimeButtonsContainer = "_ef-6";
export var dateTimeInputContainer = "_ef-7";
export var dateTimeWrapper = "_ef-8";
export var disabledTile = "_ef-0";
export var header = "_ef-2";
export var line = "_ef-3";
export var snoozeOption = "_ef-4";
export var time = "_ef-5";
export var todayTile = "_ef-9";
export var wrapper = "_ef-a";